export default [
  {
    title: "Тобі",
    link: "/you/cards",

    list: [
      {
        title: "Картки",
        link: "/you/cards",
      },
      {
        title: "Кредити",
        link: "/you/credits",
      },
      {
        title: "Депозити",
        link: "/you/deposits",
      },
      {
        title: "Платежі та перекази",
        link: "/you/payments-and-transfers",
      },
      {
        title: "Автоцивілка online",
        link: "https://polis.ua/tascombank",
      },
      {
        title: "Google Pay",
        link: "https://tascombank.ua/google_pay",
        follow: true,
      },
      {
        title: "Apple Pay",
        link: "https://tascombank.ua/apple_pay",
        follow: true,
      },
    ],
  },

  {
    title: "Твоєму бізнесу",
    link: "/your-business",
    list: [
      {
        title: "Еквайринг",
        link: "https://paytas.com.ua/",
      },
      {
        title: "Перекази на картки",
        link: "/your-business/transfer",
      },
    ],
  },
  {
    title: "Малому та середньому бізнесу",
    link: "https://tas24b.ua/",
    list: [
      {
        title: "ТАС24 Бізнес",
        link: "https://tas24b.ua/",
      },
    ],
  },
  {
    title: "Корпоративному бізнесу",
    link: "/corp-business",
    list: [
      {
        title: "Про нас",
        link: "/corp-business",
      },
      {
        title: "Стандартизовані послуги",
        link: "/corp-business",
      },
      {
        title: "Індивідуальні послуги",
        link: "/corp-business",
      },
    ],
  },
  {
    title: "Private Banking",
    link:
      "https://old.tascombank.ua/index.php?option=com_content&task=view&id=642&Itemid=208",
  },

  {
    title: "Загальні відомості",
    link: "/",

    list: [
      {
        title: "Про банк",
        link: "/our-team",
      },
      {
        title: "Кредитні посередники",
        link: "/docs",
      },
      {
        title: "Карта відділень",
        link: "/branch",
      },
      {
        title: "Контакти",
        link: "/contacts",
      },
      {
        title: "Новини",
        link: "/news",
      },
    ],
  },
  {
    title: "Завантаження",
    link: "/docs",

    list: [
      {
        title: "Тарифи та форми договорів",
        link: "/docs",
      },
      {
        title: "Управлінська звітність",
        link: "/docs",
      },
      {
        title: "Фінансова звітність та аудит",
        link: "/docs",
      },
      {
        title: "Документи пов'язані з ФГВФО",
        link: "/docs",
      },
      {
        title: "Статутні документи",
        link: "/docs",
      },
    ],
  },
]
